var spaceInvader = {
    directions: ["left", "right"],
    interval: false,
    shootInterval: false,
    defender: false,
    previousDistance: 0,
    previousKey: false,
    random: true,
    randomShoot: true,
    keyDown: false,
    stepping: false,
    shooting: false,

    init: function () {
        try {
            this.defender = document.getElementById("spaceinvader-defender");

            this.randomMove = this.randomMove.bind(this);
            this.randomShoot = this.randomShoot.bind(this);
            this.moveLeft = this.moveLeft.bind(this);
            this.moveRight = this.moveRight.bind(this);
            this.step = this.step.bind(this);
            this.shoot = this.shoot.bind(this);

            this.interval = setInterval(this.randomMove, 2000);
            this.shootInterval = setInterval(this.randomShoot, 500);
            this.watch();
        } catch (error) {
            console.error(error);
        }
    },

    watch: function () {
        // Key Press
        let parent = this;


        document.addEventListener('keyup', function (event) {
            if (parent.keyDown) {
                if (event.key == parent.previousKey) {
                    parent.previousKey = false;
                    parent.keyDown = false;
                }
            }

            if (event.key == "ArrowUp" || event.key == "ArrowDown") {
                if (parent.shooting) {
                    clearInterval(parent.shootInterval);
                    parent.shooting = false;
                }
            }
        });

        document.addEventListener('keydown', function (event) {
            if (event.key == "ArrowLeft" || event.key == "ArrowRight") {

                if (parent.random) {
                    clearInterval(parent.interval);
                    parent.random = false;
                    parent.defender.classList.add("no-animation");
                    /*let currentPosition = parent.defender.getBoundingClientRect().left;
                    console.log("Position Updated from "+parent.previousDistance+" to "+currentPosition);
                    parent.defender.style.transform = "translateX("+currentPosition+"px)";
                    parent.defender.previousDistance = currentPosition; */
                }

                parent.previousKey = event.key;
                if (!parent.keyDown) {
                    parent.keyDown = true;
                    if (!parent.stepping) {
                        parent.step();
                    }
                }

            }

            if (event.key == "ArrowUp" || event.key == "ArrowDown") {
                if (parent.randomShoot) {
                    clearInterval(parent.shootInterval);
                    parent.randomShoot = false;
                }

                if (!parent.shooting) {
                    parent.shooting = true;
                    parent.shoot();
                    parent.shootInterval = setInterval(parent.shoot, 500);
                }
            }
        });
    },

    getRandomInt: function (min, max) {
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min + 1)) + min;
    },

    randomShoot: function () {
        try {
            let shoot = this.getRandomInt(0, 10);
            this.defender.classList.remove("shoot");
            this.defender.classList.remove("shoot2");

            if (shoot == 0) {
                this.defender.classList.add("shoot");
            }
            if (shoot == 1) {
                this.defender.classList.add("shoot2");
            }
        } catch (error) {
            console.error(error);
        }
    },

    shoot: function () {
        try {
            if (!this.defender.classList.contains("shoot")) {
                this.defender.classList.add("shoot");
                setTimeout(() => {
                    spaceInvader.defender.classList.remove("shoot")
                }, 500);
            } else if (!this.defender.classList.contains("shoot2")) {
                this.defender.classList.add("shoot2");
                setTimeout(() => {
                    spaceInvader.defender.classList.remove("shoot2")
                }, 500);
            }
        } catch (error) {
            console.error(error);
        }
    },

    randomMove: function () {
        try {
            let minWidth = this.getMinWidth();
            let maxWidth = this.getMaxWidth();
            let direction = this.directions[this.getRandomInt(0, 1)];
            let distance = this.getRandomInt(minWidth, maxWidth);

            if (direction == "left") {
                distance -= this.previousDistance;
                if (distance < minWidth) {
                    distance = minWidth;
                }
                this.defender.style.transform = "translateX(" + distance + "px)";
            } else {
                this.defender.style.transform = "translateX(" + distance + "px)";
            }
            this.previousDistance = distance;
        } catch (error) {
            console.error(error);
        }
    },


    step: function () {
        try {
            this.stepping = true;
            if (this.previousKey == "ArrowLeft") {
                this.moveLeft();
            } else {
                this.moveRight();
            }

            if (this.keyDown) {
                window.requestAnimationFrame(this.step);
            } else {
                this.stepping = false;
            }
        } catch (error) {
            console.error(error);
        }
    },

    moveLeft: function () {
        let maxWidth = this.getMaxWidth();
        let minWidth = this.getMinWidth();
        let distance = this.previousDistance;
        distance -= (maxWidth / 400);
        if (distance < minWidth) {
            distance = minWidth;
        }
        this.defender.style.transform = "translateX(" + distance + "px)";
        this.previousDistance = distance;
    },

    moveRight: function () {
        let maxWidth = this.getMaxWidth();
        let distance = this.previousDistance;
        distance += (maxWidth / 400);
        if (distance > maxWidth) {
            distance = maxWidth;
        }
        this.defender.style.transform = "translateX(" + distance + "px)";
        this.previousDistance = distance;
    },

    getMaxWidth: function(){
        let parentWidth = this.defender.parentElement.offsetWidth;
        parentWidth -= this.defender.offsetWidth;
        return parentWidth;
    },

    getMinWidth: function(){
        return 0;
    }
}

spaceInvader.init();